import { render, staticRenderFns } from "./SupplierProducts.vue?vue&type=template&id=69baba3e&scoped=true"
import script from "./SupplierProducts.vue?vue&type=script&lang=js"
export * from "./SupplierProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69baba3e",
  null
  
)

export default component.exports